import { useEffect, useRef } from "react";

export function useIntesectionObserver<T extends HTMLElement>(
  callback: () => void
) {
  const ref = useRef<T>(null);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          callback();
        }
      },
      { root: null, rootMargin: "0px", threshold: 0 }
    );
    observer.observe(element);
    return () => observer.unobserve(element);
  }, [callback]);
  return ref;
}
